import styled from 'styled-components/macro'
import { useState } from 'react'
import { getFocus, useGet } from 'state/jotai'
import { _project } from 'state/store.projects'
import { active_project } from 'state/store.global'

export const Thumb = ({props, northDeg}, state) => {
  const { pin, pid } = useGet(active_project) 
  const buttonsLabel  = getFocus(_project, 'buttonsLabel')?.[pin]?.[pid] ?? []

  const fill = clr?.buttons
  
  return (
    <StyledThumb {...props}>
       <div style={{display: "flex", alignItems: "start", position: "absolute", top: "-30px", left: "-20px", justifyContent: "center", flexDirection: "column", color: "#000"}}>
            <div className='paragraph2-light' style={{ fontWeight: "500", fontSize: "14px", lineHeight: "18px", display: "flex", gap: "4px" ,color:"#004337"}}>
                <div>{northDeg}</div>
                <div style={{ textAlign: "center" }}>{buttonsLabel?.filter( btn => btn?.UILabelProperty === 'grader')[0]?.Label}</div>
            </div>
        </div> 
      <SVG></SVG>
    </StyledThumb>
  )
}

const SVG = ({children}) => {

  const [cursor, setCursor] = useState('grab')

  const svgPos = { 
    overflow: 'visible', 
    width: '100%',
    height: '100%',
    cursor:cursor
  }


  return (
        <StyledThumb>
        <div style={thumbBackground} 
        onMouseDown={()=>setCursor('grabbing')}
          onMouseUp={()=>setCursor('grab')}
          onMouseLeave={()=>setCursor('grab')}
          onMouseEnter={()=>setCursor('grab')}>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            viewBox='3 3 42 42'
            style={svgPos}
          >
            <defs>
              <clipPath id='ab'>
                <path fill='none' d='M0 0h53.823v53.822H0z'/>
              </clipPath>
            </defs>
            <g clipPath='url(#ab)' transform="translate(-3.0634689,-1.5639996)">
              <path
                fill={clr.primary_text}
                d='
                  m27.195 1.564
                  a24.127 24.127 0 1 0 12.06 3.233 24.128 24.128 0 0 0-12.06-3.233
                  m-8.12 28.079
                  a1.725 1.725 0 1 1-2.43 2.448l-5.171-5.167
                  a1.725 1.725 0 0 1-.009-2.438l.009-.009 5.171-5.171
                  a1.725 1.725 0 1 1 2.43 2.448l-3.947 3.937Z
                  m8.119-.5
                  a3.446 3.446 0 1 1 2.438-1.009 3.446 3.446 0 0 1-2.437 1.008
                  m15.72-2.218-5.171 5.167
                  a1.725 1.725 0 0 1-2.43-2.448l3.945-3.952-3.947-3.947
                  a1.725 1.725 0 1 1 2.43-2.448l5.171 5.171
                  a1.724 1.724 0 0 1 .009 2.438l-.009.009z'
              />
            </g>
          </svg>
        </div>
      </StyledThumb>
  )
}


const Svg = styled.div`
  width:30px;
  height:30px;
  position:absolute;
  top:50%;
  left:50%;
  transform:translate(-50%,-50%);
  border-radius:50%;
  &: focus-visible {
    outline: none;
  }
`

const thumbBackground = {
  backgroundColor: '#ffffff',
  borderRadius: '50%',
  width: '100%', 
  height: '100%',
}

const StyledThumb = styled.div`
  position: absolute;
  height: 35px;
  width: 35px;
  text-align: center;
  border-radius: 50%;
  bottom: -2px;
`
